import { render, staticRenderFns } from "./score-en.vue?vue&type=template&id=4ae9c618&scoped=true"
import script from "./score-en.vue?vue&type=script&lang=js"
export * from "./score-en.vue?vue&type=script&lang=js"
import style0 from "./score-en.vue?vue&type=style&index=0&id=4ae9c618&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae9c618",
  null
  
)

export default component.exports